import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const GuardianChecks = () =>
  import('@/pages/partnerGuardianAndAlerts/guardianChecks/GuardianChecks.vue');
const StationOfflineStatusDashboard = () =>
  import('@/pages/partnerGuardianAndAlerts/guardianChecks/StationOfflineStatusDashboard.vue');
const GuardianCheckOfflineHistory = () =>
  import('@/pages/partnerGuardianAndAlerts/guardianChecks/GuardianCheckOfflineHistory.vue');
const GuardianCheckMapView = () =>
  import('@/pages/partnerGuardianAndAlerts/guardianChecks/GuardianCheckMapView.vue');
const CashierSystemConfigurationsCreation = () =>
  import('@/pages/partnerGuardianAndAlerts/cashierSystemConfigurations/CashierSystemConfigurationsCreation.vue');
const CashierSystemConfigurationsView = () =>
  import('@/pages/partnerGuardianAndAlerts/cashierSystemConfigurations/CashierSystemConfigurationsView.vue');
const CashierSystemConfigurationsEdit = () =>
  import('@/pages/partnerGuardianAndAlerts/cashierSystemConfigurations/CashierSystemConfigurationsEdit.vue');
const CashierSystemConfigurationsList = () =>
  import('@/pages/partnerGuardianAndAlerts/cashierSystemConfigurations/CashierSystemConfigurationsList.vue');
const MocPartnerConfigurationsCreation = () =>
  import('@/pages/partnerGuardianAndAlerts/mocPartnerConfigurations/MocPartnerConfigurationsCreation.vue');
const MocPartnerConfigurationsView = () =>
  import('@/pages/partnerGuardianAndAlerts/mocPartnerConfigurations/MocPartnerConfigurationsView.vue');
const MocPartnerConfigurationsEdit = () =>
  import('@/pages/partnerGuardianAndAlerts/mocPartnerConfigurations/MocPartnerConfigurationsEdit.vue');
const MocPartnerConfigurationsList = () =>
  import('@/pages/partnerGuardianAndAlerts/mocPartnerConfigurations/MocPartnerConfigurationsList.vue');
const GuardianCheckAlertsEdit = () =>
  import('@/pages/partnerGuardianAndAlerts/alerts/PartnerGuardianAlertsEdit.vue');
const GuardianCheckAlertsList = () =>
  import('@/pages/partnerGuardianAndAlerts/alerts/PartnerGuardianAlertsList.vue');

export const guardianSystemAndAlertsRoutes: AppRouteRecordRaw[] = [
  {
    path: '/guardian-system-and-alerts',
    component: Body,
    meta: {
      breadcrumb: 'Guardian System and Alerts',
    },
    children: [
      {
        path: 'guardian-checks',
        name: 'GuardianChecks',
        component: GuardianChecks,
        meta: {
          title: ' Guardian System and Alerts - Guardian Checks | ryd Portal',
          breadcrumb: 'Guardian Checks',
        },
      },
      {
        path: 'station-offline-status-dashboard',
        name: 'StationOfflineStatusDashboard',
        component: StationOfflineStatusDashboard,
        meta: {
          title: ' Guardian System and Alerts - Station Offline Status Dashboard | ryd Portal',
          breadcrumb: 'Station Offline Status Dashboard',
        },
      },
      {
        path: 'station-offline-history',
        name: 'GuardianCheckOfflineHistory',
        component: GuardianCheckOfflineHistory,
        meta: {
          title: ' Guardian System and Alerts - Offline History | ryd Portal',
          breadcrumb: 'Station Offline History',
        },
      },
      {
        path: 'guardian-check-map-view',
        name: 'GuardianCheckMapView',
        component: GuardianCheckMapView,
        meta: {
          title: ' Guardian System and Alerts - Guardian Check Map View | ryd Portal',
          breadcrumb: 'Guardian Check Map View',
        },
      },
      {
        path: 'cashier-system-configuration/create',
        name: 'Cashier System Configuration Create',
        component: CashierSystemConfigurationsCreation,
        meta: {
          title: ' Guardian System and Alerts - Cashier System Configuration Create | ryd Portal',
          breadcrumb: 'Create Cashier System Configuration',
        },
      },
      {
        path: 'cashier-system-configuration/view',
        name: 'Cashier System Configuration View',
        component: CashierSystemConfigurationsView,
        meta: {
          title: ' Guardian System and Alerts - Cashier System Configuration View | ryd Portal',
          breadcrumb: 'View Cashier System Configuration',
        },
      },
      {
        path: 'cashier-system-configuration/edit',
        name: 'Cashier System Configuration Edit',
        component: CashierSystemConfigurationsEdit,
        meta: {
          title: ' Guardian System and Alerts - Cashier System Configuration Edit | ryd Portal',
          breadcrumb: 'Edit Cashier System Configuration',
        },
      },
      {
        path: 'cashier-system-configuration/list',
        name: 'Cashier System Configuration List',
        component: CashierSystemConfigurationsList,
        meta: {
          title: ' Guardian System and Alerts - Cashier System Configuration List| ryd Portal',
          breadcrumb: 'Cashier System Configurations',
        },
      },
      {
        path: 'moc-partner-configuration/create',
        name: 'MOC Partner Configuration Create',
        component: MocPartnerConfigurationsCreation,
        meta: {
          title: ' Guardian System and Alerts - MOC Partner Configuration Create | ryd Portal',
          breadcrumb: 'Create MOC Partner Configuration',
        },
      },
      {
        path: 'moc-partner-configuration/view',
        name: 'MOC Partner Configuration View',
        component: MocPartnerConfigurationsView,
        meta: {
          title: ' Guardian System and Alerts - MOC Partner Configuration View | ryd Portal',
          breadcrumb: 'View MOC Partner Configuration',
        },
      },
      {
        path: 'moc-partner-configuration/edit',
        name: 'MOC Partner Configuration Edit',
        component: MocPartnerConfigurationsEdit,
        meta: {
          title: ' Guardian System and Alerts - MOC Partner Configuration Edit | ryd Portal',
          breadcrumb: 'Edit MOC Partner Configuration',
        },
      },
      {
        path: 'moc-partner-configuration/list',
        name: 'MOC Partner Configuration List',
        component: MocPartnerConfigurationsList,
        meta: {
          title: ' Guardian System and Alerts - MOC Partner Configuration List| ryd Portal',
          breadcrumb: 'MOC Parnter Configurations',
        },
      },
      {
        path: 'alerts/edit',
        name: 'Alerts Edit',
        component: GuardianCheckAlertsEdit,
        meta: {
          title: ' Guardian System and Alerts - Alerts Edit | ryd Portal',
          breadcrumb: 'View And Edit an Alert',
        },
      },
      {
        path: 'alerts/list',
        name: 'Alerts List',
        component: GuardianCheckAlertsList,
        meta: {
          title: ' Guardian System and Alerts - Alerts List| ryd Portal',
          breadcrumb: 'Alerts',
        },
      },
    ],
  },
];
